import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'
import lodash from 'lodash'
import VueMoment from 'vue-moment'
import VeeValidate from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import vueNumeralFilterInstaller from 'vue-numeral-filter'

/* const options = { name: 'lodash' } // customize the way you want to call it */

import './assets/sass/himydata.scss'

// Plugins
/* import GlobalDirectives from './globalDirectives' */
import GlobalComponents from './globalComponents'

Vue.config.productionTip = false

Vue.prototype._ = lodash
Vue.prototype.$appName = 'Himydata'
Vue.prototype.$appConfig = {
    function: {
        title: 'Function',
        icon: 'mdi-function-variant',
    },
    api: {
        title: 'Api',
        icon: 'mdi-access-point',
    },
    dataset: {
        title: 'Dataset',
        icon: 'mdi-database',
    },
    trigger: {
        title: 'Trigger',
        icon: 'mdi-flash',
        color: '#0e264a',
    },
    query: {
        title: 'Query',
        icon: 'clipboard-text-play-outline',
        color: 'green',
    },
    date_time: {
        title: 'Date & time',
        icon: 'mdi-calendar-clock',
        color: 'blue-grey',
    },
    objects: [{
            type: 'dashboard',
            label: 'Dashboard',
            plural: 'dashboards',
            description: 'Dashboard is really cool',
            icon: 'mdi-view-dashboard-outline',
            CreateInFullscreen: false,
            identifier: 'id',

        },
        {
            type: 'query',
            label: 'Query',
            plural: 'queries',
            description: '',
            icon: 'mdi-console',
            CreateInFullscreen: true,
            identifier: 'id',
        },
        {
            type: 'dataset',
            label: 'Dataset',
            plural: 'datasets',
            description: '',
            icon: 'mdi-database',
            CreateInFullscreen: true,
            identifier: 'hmd_id',
        },
        {
            type: 'function',
            label: 'Function',
            plural: 'functions',
            description: '',
            icon: 'mdi-function-variant',
            CreateInFullscreen: true,
            identifier: 'id',
        },
        {
            type: 'integration',
            label: 'Connector',
            plural: 'configs',
            description: '',
            icon: 'mdi-power-plug',
            CreateInFullscreen: true,
            identifier: 'id',
        },
        {
            type: 'api',
            label: 'Api',
            plural: 'apis',
            description: '',
            icon: 'mdi-access-point',
            CreateInFullscreen: true,
            identifier: 'id',
        },
        {
            type: 'trigger',
            label: 'Task',
            plural: 'triggers',
            description: '',
            icon: 'mdi-flash',
            CreateInFullscreen: true,
            identifier: 'id',
        },
    ],
    graphColors: [
        { backgroundColor: '#2E7D32', borderColor: '#2E7D32' },
        { backgroundColor: '#01579B', borderColor: '#01579B' },
        { backgroundColor: '#f87979', borderColor: '#f87979' },
    ],
    loading: false,
}

/* Vue.use(GlobalDirectives) */
Vue.use(GlobalComponents)
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' })
Vue.use(VeeValidate)
Vue.use(VueMoment)
Vue.use(VueClipboard)
Vue.use(Vuex)
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app')
